import { render, staticRenderFns } from "./SectionIndex.vue?vue&type=template&id=329c5d14&scoped=true"
import script from "./SectionIndex.vue?vue&type=script&lang=js"
export * from "./SectionIndex.vue?vue&type=script&lang=js"
import style0 from "./SectionIndex.vue?vue&type=style&index=0&id=329c5d14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329c5d14",
  null
  
)

export default component.exports